import React from "react";
import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import { Trans } from "react-i18next";
import i18n from "i18next";
import {
  Callout,
  Card,
  HTMLSelect,
  Icon,
  Spinner,
  Tooltip,
} from "@blueprintjs/core";

import { mefInterval, mefMontantStr } from "../../../utils/mef";
import { MultiBarChart } from "../../Charts/BarChart";

export default class ParkingTimeStat extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      by: "by park",
    };
  }

  onByChange() {
    let url = "";
    switch (this.state.by) {
      case "by user type":
        url = "/activity/stmt/time/usertypes?";
        break;
      default:
      case "by park":
        url = "/activity/stmt/time/parks?";
        break;
    }
    this.setState({ loading: true }, () => {
      authenticatedGetFetch(url + this.props.urlsearchparams, (response) => {
        this.setState({
          loading: false,
          barStmtTimeData: response["data"],
          barStmtTimeLabels: response["periods"],
        });
      });
    });
  }

  componentDidMount() {
    let ld1 = true;
    let ld2 = true;
    let ld3 = true;
    let ld4 = true;

    if (this.props.urlsearchparams !== undefined) {
      this.setState({ loading: true }, () => {
        authenticatedGetFetch(
          "/activity/stmt/time/parks?" + this.props.urlsearchparams,
          (response) => {
            ld1 = false;
            this.setState({
              loading: ld1 || ld2 || ld3 || ld4,
              barStmtTimeData: response["data"],
              barStmtTimeLabels: response["periods"],
            });
          }
        );

        authenticatedGetFetch(
          "/activity/stmt/averagetime?" + this.props.urlsearchparams,
          (response) => {
            ld2 = false;
            this.setState({
              loading: ld1 || ld2 || ld3 || ld4,
              averageTimeGlobal: response.global,
              averageTimeTk: response.tk,
              averageTimeSub: response.sub,
            });
          }
        );

        authenticatedGetFetch(
          "/activity/stmt/averageamount?" + this.props.urlsearchparams,
          (response) => {
            ld3 = false;
            this.setState({
              loading: ld1 || ld2 || ld3 || ld4,
              averageAmount: response.avgamt,
            });
          }
        );

        authenticatedGetFetch(
          "/activity/rotation?" + this.props.urlsearchparams,
          (response) => {
            ld4 = false;
            this.setState({
              loading: ld1 || ld2 || ld3 || ld4,
              rotation: response,
            });
          }
        );
      });
    }
  }

  render() {
    if (this.props.urlsearchparams !== undefined)
      return (
        <Callout icon="time" title={<Trans>parking time</Trans>}>
          {this.state.loading ? (
            <Spinner />
          ) : this.state.barStmtTimeData !== undefined &&
            this.state.barStmtTimeData.length > 0 ? (
            <>
              <HTMLSelect
                value={this.state.by}
                options={[
                  { label: i18n.t("by park"), value: "by park" },
                  { label: i18n.t("by user type"), value: "by user type" },
                ]}
                onChange={(s) => {
                  this.setState({ by: s.target.value }, () =>
                    this.onByChange()
                  );
                }}
              />
              <div className="flexbox-center">
                <MultiBarChart
                  datasets={this.state.barStmtTimeData}
                  labels={this.state.barStmtTimeLabels}
                  title={i18n.t(
                    this.state.by === "by park"
                      ? "parking time in one-hour blocks of time per park"
                      : "parking time in one-hour blocks of time per user type"
                  )}
                  large={true}
                />
              </div>
              <Card>
                <Callout>
                  <Trans>average parking time</Trans> :{" "}
                  <b>
                    {mefInterval(parseInt(this.state.averageTimeGlobal) * 60)}
                  </b>
                  <Callout>
                    {this.state.averageTimeTk && (
                      <div>
                        <Trans>userType0</Trans> :{" "}
                        <b>
                          {mefInterval(parseInt(this.state.averageTimeTk) * 60)}
                        </b>
                      </div>
                    )}
                    {this.state.averageTimeSub && (
                      <div>
                        <Trans>userType2</Trans> :{" "}
                        <b>
                          {mefInterval(
                            parseInt(this.state.averageTimeSub) * 60
                          )}
                        </b>
                      </div>
                    )}
                  </Callout>
                </Callout>
                <Callout>
                  <Trans>ticket moyen</Trans>{" "}
                  <Tooltip
                    content={
                      <div>
                        <Trans>help average ticket</Trans>
                      </div>
                    }
                  >
                    <Icon icon="help" />
                  </Tooltip>{" "}
                  : <b>{mefMontantStr(this.state.averageAmount)}</b>
                </Callout>
                {this.state.rotation === undefined ? null : (
                  <Callout>
                    {this.state.rotation.rotation !== null && (
                      <span>
                        <Trans>rotation/day</Trans>{" "}
                        <Tooltip
                          content={
                            <div>
                              <Trans>help rotation/day</Trans>
                            </div>
                          }
                        >
                          <Icon icon="help" />
                        </Tooltip>{" "}
                        : <b>{this.state.rotation.rotation.toFixed(2)}</b>
                      </span>
                    )}
                    <Callout>
                      <b>{this.state.rotation.entries}</b>{" "}
                      <Trans>entries</Trans> <Trans>for a capacity of</Trans>{" "}
                      <b>{this.state.rotation.capacity}</b>
                    </Callout>
                  </Callout>
                )}
              </Card>
            </>
          ) : (
            <Callout intent="primary">
              <Trans>no data for the period</Trans>
            </Callout>
          )}
        </Callout>
      );
    else return null;
  }
}
